import { atom } from "recoil"
import { PlanModelDetail } from "src/apis/paidTeam/getOrderDetail"

export const orderPlanState = atom<PlanModelDetail>({
  key: "atoms/paidTeam/orderPlanState",
  default: undefined,
})
